<template>
  <div class="logo flex-shrink-0 ml-3 sm:ml-0 md:ml-0 lg:ml-0">
    <img
      src="@/assets/logo-stikes.png"
      alt="Logo"
      class="w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-[130px] lg:h-[130px]"
    />
  </div>
</template>

